import {CSSObject, styled} from "@core-ui/react-stitch";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import colorContrast from "color-contrast";
import {SolidColorSwatchProps} from "../types";

export const isLowContrast = (customColor: CSSObject["background"]) => {
  try {
    return colorContrast("white", customColor) < 1.3;
  } catch (err) {
    return "";
  }
};

const hasComma = (
  boxShadow: CSSObject["boxShadow"],
  customColor: CSSObject["background"]
) => (boxShadow && isLowContrast(customColor) ? "," : "");

export const CircleCustomColorSwatch = styled.div<
  Pick<SolidColorSwatchProps, "selected" | "size" | "customColor" | "boxShadow">
>(({customColor, theme, boxShadow}) => ({
  width: "100%",
  height: "100%",
  margin: 0,
  borderRadius: "50%",
  zIndex: 1,
  background: customColor,
  boxShadow: `${boxShadow} ${hasComma(boxShadow, customColor)} ${
    isLowContrast(customColor)
      ? `inset 0 0 0 1px ${theme?.color?.gray05 ?? "transparent"}`
      : ""
  }`,
}));

export const SquareCustomColorSwatch = styled.div<
  Pick<SolidColorSwatchProps, "selected" | "size" | "customColor" | "boxShadow">
>(({customColor, theme, boxShadow}) => ({
  width: "100%",
  height: "100%",
  borderRadius: "0%",
  margin: 0,
  zIndex: 1,
  background: customColor,
  boxShadow: `${boxShadow} ${hasComma(boxShadow, customColor)} ${
    isLowContrast(customColor)
      ? `inset 0 0 0 1px ${theme?.color?.gray05 ?? "transparent"}`
      : ""
  }`,
}));
